import { NearestStationModel, NearestStationTypeModel } from '../models/nearest-station';

export class NearestStationAdapter {
  /**
   * Converte os dados da API para o modelo NearestStationModel
   * @param data Dados retornados pela API
   * @returns Objeto NearestStationModel
   */
  static fromApi(data: any): NearestStationModel {
    return {
      id: data.id,
      code: data.code,
      identifier: data.identifier,
      description: data.description,
      latitude: data.latitude,
      longitude: data.longitude,
      altitude: data.altitude,
      startingYearHistory: data.startingYearHistory,
      radiationBalance: data.radiationBalance,
      radiationBalanceValue: data.radiationBalanceValue,
      heatFlow: data.heatFlow,
      heatFlowValue: data.heatFlowValue,
      automaticWeatherStation: data.automaticWeatherStation,
      publishData: data.publishData,
      estimateTemperature: data.estimateTemperature,
      sadEnabled: data.sadEnabled,
      active: data.active,
      inactivityType: data.inactivityType,
      inactivityDescription: data.inactivityDescription,
      cityId: data.cityId,
      weatherStationType: this.adaptWeatherStationType(data.weatherStationType),
      equipmentResponsibleId: data.equipmentResponsibleId,
      propertyId: data.propertyId,
      creationDate: data.creationDate,
      updateDate: data.updateDate,
      userNameCreate: data.userNameCreate,
      userNameUpdate: data.userNameUpdate,
    };
  }

  /**
   * Converte os dados do tipo de estação meteorológica
   * @param data Dados do tipo de estação
   * @returns Objeto NearestStationTypeModel
   */
  private static adaptWeatherStationType(data: any): NearestStationTypeModel {
    return {
      id: data.id,
      name: data.name,
      code: data.code,
      creationDate: data.creationDate,
      updateDate: data.updateDate,
      userNameCreate: data.userNameCreate,
      userNameUpdate: data.userNameUpdate,
    };
  }
}
